import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { BottomNav } from './BottomNav';
import { MobileHeader } from './MobileHeader';

export function AppShell() {
  return (
    <div className="min-h-dvh bg-slate-50 dark:bg-slate-950 pb-[calc(env(safe-area-inset-bottom)+68px)] md:pb-0">
      <MobileHeader />
      <TopNav />
      <main className="p-4 md:p-6 max-w-7xl mx-auto">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
